import { BasePersonalFinancialStatementResource, PersonalFinancialStatementFetchOptions, PersonalFinancialStatementResourceType } from './basePersonalFinancialStatementResource'
import { getHomeMetricsForDateRange } from '@/services/personalFinancialStatement'
import { log } from '@/utils/logger'
import { RecordSnapshotRetrievalStrategy, HomeMetricsForDateRangeData } from 'aven_types'

const LOOKBACK_MONTHS = 24
const TIME_INTERVAL_MS = 7 * 24 * 60 * 60 * 1000 // 1 week in milliseconds

export class PersonalFinancialStatementHomeMetricsForDateRangeResource extends BasePersonalFinancialStatementResource<PersonalFinancialStatementResourceType.HOME_VALUE_AND_EQUITY_FOR_DATE_RANGE> {
    constructor() {
        super(PersonalFinancialStatementResourceType.HOME_VALUE_AND_EQUITY_FOR_DATE_RANGE)
    }

    protected async fetchData(options?: PersonalFinancialStatementFetchOptions): Promise<HomeMetricsForDateRangeData[]> {
        log.info('PersonalFinancialStatementHomeMetricsForDateRangeResource.fetchData: Fetching home value and equity data')

        const now = new Date()
        const start = new Date(new Date().setMonth(now.getMonth() - LOOKBACK_MONTHS))
        const response = await getHomeMetricsForDateRange({
            dateRange: {
                startDate: start,
                endDate: now,
            },
            timeIntervalMs: TIME_INTERVAL_MS,
            sourceUniqueId: null,
            retrievalStrategy: RecordSnapshotRetrievalStrategy.SINGLE_SOURCE_WATERFALL_HIGHEST_RECORD_COUNT,
            rateLimitingOptions: {
                turnOffRateLimiter: false,
                onlyCountSuccessfulFetchesWhenRateLimiting: true,
            },
            fetchNewRecordSnapshotsOptions: {
                doNotFetchNewRecordsFromSource: false,
                fetchKeyStatusesFromSourceValues: true,
                onlyFetchBetweenMostRecentSnapshotAndCurrentDate: options?.onlyFetchBetweenMostRecentSnapshotAndCurrentDate ?? true,
                fetchSnapshotDateRangeOverride: null,
            },
        })

        log.info('PersonalFinancialStatementHomeMetricsForDateRangeResource.fetchData: Fetched %{count} home value and equity records', { count: response.data.payload.length })

        return response.data.payload
    }
}
